<script>
    // Import Social component
    import Social from '../ui/social.svelte';

    // Import settings
    export let infoPersonal;
</script>

<div class="divide-y divide-zinc-900">
    <div></div>
    <div class="bg-white pt-8 md:py-6 md:pt-14">
        <div class="container mx-auto">
            <div class="text-2xl md:text-4xl text-zinc-900 uppercase font-bold text-center pb-2">{infoPersonal.name} {infoPersonal.surname}</div>
            <Social social={infoPersonal.social}/>
        </div>
    </div>
</div>